import React from 'react';
import {
  columnCode,
  columnDescription,
  columnName,
  columnNameLink,
  columnNameReference,
  hasColumn,
} from '@/constants/fields';
import TableSortedColumn from './TableSortedColumn';

const SortableNameDescriptionColumns = ({
  category,
  columns = [],
  onOrderByColumn,
  orderBy,
  singleSorting,
}) => (
  <>
    {hasColumn(columns, [columnName, columnNameLink]) && (
      <TableSortedColumn
        name={columnName}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting={singleSorting}
        sortable={category}
      />
    )}
    {hasColumn(columns, columnNameReference) && (
      <TableSortedColumn
        name={columnNameReference}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting={singleSorting}
        sortable={category}
      />
    )}
    {hasColumn(columns, columnCode) && (
      <TableSortedColumn
        name={columnCode}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting={singleSorting}
        sortable={category}
      />
    )}
    {hasColumn(columns, columnDescription) && (
      <TableSortedColumn
        name={columnDescription}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting={singleSorting}
        sortable={category}
      />
    )}
  </>
);

export default SortableNameDescriptionColumns;
